import { render, staticRenderFns } from "./BrandImg.vue?vue&type=template&id=fb45f5c6&"
import script from "./BrandImg.vue?vue&type=script&lang=js&"
export * from "./BrandImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports